(function () {
    'use strict';

    angular.module("imApp").factory("metaTableService", ['$ihttp', function ($ihttp) {
        let service = {
            getMetaTable: function (parms) {
                return $ihttp.post({
                    method: 2372,
                    parameters: parms || {}
                });
            },
            listRelatedToMetaTables: function (parms) {
                return $ihttp.post({
                    method: 2373,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2374,
                    parameters: edit
                });
            },
            deleteObj: function (edit) {
                return $ihttp.post({
                    method: 2376,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
